module.exports = __webpack_public_path__ + "static/media/asin_image.9e3a3a17.png";